import React, { useState } from "react";
import {
  Dialog,
  Button,
  Box,
  TextField,
  CircularProgress,
  TextareaAutosize,
} from "@mui/material";
import styles from "./TaxInvoices.module.css";
import { useAuthUser } from "react-auth-kit";
import { useSelector } from "react-redux";

function EditInvoiceFooter(props: any) {
  const {
    handleChangeInvoiceFooter,
    handleCancelInvoiceFooter,
    UpdateInvoiceFooter,
    invoiceFooter,
  } = props;
  const auth = useAuthUser();
  const authUser = auth();
  const { invoiceFooterUpdateLoading } = useSelector(
    (state: any) => state.appSettings
  );

  const handleCancel = () => {
    handleCancelInvoiceFooter();
  };

  const handleSaveClick = async (event: any) => {
    event.preventDefault();

    try {
      const body: any = {
        instituteId: authUser?.institute?.[0]?.instituteId,
        invoiceFooter: invoiceFooter,
      };
      UpdateInvoiceFooter(body);
    } catch (error) {}
  };

  return (
    <Box>
      <div className={styles.editInvoice}>Edit Invoice Footer</div>
      <TextareaAutosize
        className="invoice-textarea"
        value={invoiceFooter}
        onChange={(e) => {
          handleChangeInvoiceFooter(e.target.value);
        }}
        style={{
          width: "100%",
          resize: "none",
          border: "1px solid #CFCFCF",
          borderRadius: "4px",
          color: "#667085",
          padding: "5px",
          fontSize: "12px",
          fontFamily: "poppins",
        }}
        maxLength={1000}
        placeholder="Enter text here for the invoice footer..."
        minRows={7}
        maxRows={7}
      />
      <div
        style={{
          textAlign: "right",
          fontSize: "10px",
          color: "#555",
        }}
      >
        {invoiceFooter && invoiceFooter?.length} / 1000 of characters
      </div>
      <Box sx={{ marginTop: "24px", display: "flex", gap: "12px" }}>
        <Button
          sx={{
            color: "#BFBFBF",
            border: "1px solid #BFBFBF",
            background: "#FFF",
            textTransform: "capitalize",
          }}
          variant="outlined"
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          sx={{ textTransform: "capitalize" }}
          variant="contained"
          onClick={handleSaveClick}
          disabled={invoiceFooterUpdateLoading}
        >
          {invoiceFooterUpdateLoading ? (
            <CircularProgress size={20} color={"inherit"} />
          ) : (
            "Save"
          )}
        </Button>
      </Box>
    </Box>
  );
}
export default EditInvoiceFooter;
